
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset_password",
      function () {
        return require("private-next-pages/reset_password/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reset_password"])
      });
    }
  